import { render, staticRenderFns } from "./MetadadosCampoDinamicoTextarea.vue?vue&type=template&id=68f8fe26"
import script from "./MetadadosCampoDinamicoTextarea.vue?vue&type=script&lang=js"
export * from "./MetadadosCampoDinamicoTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports